import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AutoLoginGuard } from "./auto-login.guard";
import { AcessoBloqueadoComponent } from "./components/acesso-bloqueado/acesso-bloqueado.component";
import { LoginComponent } from "./components/login/login.component";
import { NaoAutorizadoComponent } from "./components/nao-autorizado/nao-autorizado.component";

const routes: Routes = [
  { path: "login", component: LoginComponent, canActivate: [AutoLoginGuard] },
  { path: "nao-autorizado", component: NaoAutorizadoComponent },
  { path: "acesso-bloqueado", component: AcessoBloqueadoComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SecutiryRoutingModule {}
